<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <div class="content-title content-mb-14">
      2. Полное наименование проекта
    </div>
    <uf_name></uf_name>

    <div class="content-title content-mb-14">
      3. Программа финансовой поддержки
      <a
        v-show="
          $parent.getProgramCode() === 'working' ||
            $parent.getProgramCode() === 'working_rfrp'
        "
        @click="$parent.showWorkingModal = !$parent.showWorkingModal"
        class="icon-help"
      />
    </div>
    <uf_support_prog_id />

    <div class="content-title content-mb-14">
      4. Оказывал ли региональный фонд развития промышленности методологическую
      и/или информационную помощь при подготовке заявки в Фонд развития
      промышленности:
    </div>
    <uf_is_reg_fond_help />

    <div class="content-title content-mb-14">
      5. Требуемый объем финансирования со стороны Фонда, тыс. руб.
    </div>
    <uf_sum_request />

    <div class="content-title content-mb-14">6. Сроки займа, мес.</div>
    <uf_month_return />

    <div class="content-title content-mb-14">7. Отрасль промышленности</div>
    <uf_industry_id></uf_industry_id>

    <div class="content-title content-mb-14">8. Подотрасль промышленности</div>
    <uf_sub_industry_id></uf_sub_industry_id>

    <div class="content-title content-mb-14">
      9. Информация о продукции (в соответствии с перечнем ОКПД)
    </div>
    <okpd></okpd>

    <div class="content-title content-mb-14">
      10. Если продукция вашего проекта является высокотехнологичной и включена
      в приказ Минпромторга России от 16.09.2020 N 3092 или 02.07.2020 № 2095,
      укажите наименование продукции:
    </div>
    <HighTechList></HighTechList>

    <div class="content-title content-mb-14">11. Аннотация проекта</div>
    <uf_annotation></uf_annotation>

    <div class="content-title content-mb-14">
      12. Имеющийся результат по проекту
    </div>
    <uf_available_results></uf_available_results>

    <div class="content-title content-mb-14">13. Место реализации проекта</div>
    <place></place>

    <div class="content-title content-mb-14">
      14. Ключевые исполнители (поставщик продукции, услуг, на которого
      приходится не менее 20% от суммы займа)
      <VDropdown
        tag="span"
        trigger="click"
        placement="bottom"
        popperClass="custom-popper"
        :distance="25"
        style="display: inline"
      >
        <a class="icon-help" />
        <template #popper>
          <div class="custom-popper-content">
            {{ h4tooltip }}
          </div>
        </template>
      </VDropdown>
    </div>
    <subcontractors></subcontractors>

    <div class="content-title content-mb-14">
      15. Включение проекта в отраслевые планы импортозамещения
    </div>
    <import_plan>tree_group_med_oborudovanie</import_plan>

    <div v-if="project.UF_INDICATOR_VERSION === 1">
      <div class="content-title content-mb-14">
        16. Сбыт продукции проекта, обеспечивающий выход на целевой объем продаж
      </div>
      <export_countries></export_countries>

      <div
        class="row myrow content-mb-42"
        v-if="project.UF_INDICATOR_VERSION === 1"
      >
        <div class="col-xs-12 mycol">
          <textarea
            :disabled="$parent.projectDisabled"
            v-model="project.UF_SALE"
            class="i-main-style t-dop-style i-wid-50"
            placeholder="Укажите планируемые объемы продаж/спроса, наличие инструментов реализации продукции проекта, перечень договоренностей по реализации продукции проекта: соглашения, предварительные соглашения, переговоры и т.п."
          ></textarea>
        </div>
      </div>
    </div>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import VueTagsInput from "@johmun/vue-tags-input";
import { AUTH_URL } from "@/common/config";
import Vue from "vue";
import SystemIntegrator from "@/components/project/form/partial/SystemIntegrator";
import Digital_solution from "@/components/project/form/partial/DigitalSolution";
import System_equipment from "@/components/project/form/partial/SystemEquipment";
import Uf_name from "@/components/project/form/partial/uf_name";
import Uf_support_prog_id from "@/components/project/form/partial/uf_support_prog_id";
import Uf_sum_request from "@/components/project/form/partial/uf_sum_request";
import Uf_month_return from "@/components/project/form/partial/uf_month_return";
import Uf_industry_id from "@/components/project/form/partial/uf_industry_id";
import Uf_sub_industry_id from "@/components/project/form/partial/uf_sub_industry_id";
import Okpd from "@/components/project/form/partial/okpd";
import Uf_annotation from "@/components/project/form/partial/uf_annotation";
import Uf_available_results from "@/components/project/form/partial/uf_available_results";
import Place from "@/components/project/form/partial/place";
import Subcontractors from "@/components/project/form/partial/subcontractors";
import Import_plan from "@/components/project/form/partial/import_plan";
import Uf_result_natural from "@/components/project/form/partial/uf_result_natural";
import Target_years from "@/components/project/form/partial/target_years";
import Export_countries from "@/components/project/form/partial/export_countries";
import Uf_is_reg_fond_help from "@/components/project/form/partial/uf_is_reg_fond_help";
import PromProducts from "@/components/project/form/partial/PromProducts";
import HighTechList from "@/components/project/form/partial/HighTechList";
import { Dropdown as VDropdown } from "floating-vue";
import HelpFiledStep2 from "@/components/project/form/subpartial/HelpFiledStep2.vue";

export default {
  name: "step2",
  props: ["step", "project"],
  components: {
    HighTechList,
    PromProducts,
    Uf_is_reg_fond_help,
    Export_countries,
    Target_years,
    Uf_result_natural,
    Import_plan,
    Subcontractors,
    Place,
    Uf_available_results,
    Uf_annotation,
    Okpd,
    Uf_sub_industry_id,
    Uf_industry_id,
    Uf_month_return,
    Uf_sum_request,
    Uf_support_prog_id,
    Uf_name,
    System_equipment,
    Digital_solution,
    SystemIntegrator,
    VueTagsInput,
    VDropdown,
    HelpFiledStep2
  },
  data() {
    return {
      selectedTags: [],
      hCoExecutorTooltip:
        "Заполнение данного поля позволит Вам ускорить процедуру проведения акцептов платежей после получения средств займа.",
      h14tooltipShow: false,
      h14tooltip:
        "<img src='https://lkbe.frprf.ru/images/project/p13_info.png' />",
      siteUrl: "",
      tag: "",
      tags: [],
      RESULT_INTELLECTUAL_ACTIVITY: false,
      h18tooltip:
        'Ставка по предоставляемому целевому займу может быть изменена Фондом на 1% годовых,  если  выполнено требование п.7.3 Стандарта "Цифровизация промышленности"',
      h15tooltip:
        "Для возможного применения ставки 1 (один) процент годовых к займам, финансируемым по\n" +
        "                                программе «Цифровизация промышленности», Системный интегратор цифровых и\n" +
        "                                технологических\n" +
        "                                решений (далее - Системный интегратор), привлеченный в качестве Ключевого\n" +
        "                                исполнителя\n" +
        "                                (Одобренный ФРП при принятии решения о предоставлении займа) по проекту, должен\n" +
        "                                соответствовать следующим критериям:<br/>\n" +
        "                                1. являться резидентом РФ (определяется в соответствии с законодательством о валютном регулировании и валютном контроле);<br/>\n" +
        "                                2. не являться дочерним хозяйственным обществом (определяется в соответствии с ч. 1 ст. 67.3 ГК РФ) юридических лиц, созданных в соответствии с законодательством иностранных государств;<br/>\n" +
        "                                3. не находиться  процессе ликвидации или банкротства;<br/>\n" +
        "                                4. выплаты Заемщика по договорам/контрактам, заключенным с Системным интегратором в ходе реализации проекта составляют более 50% от суммы займа;<br/>\n" +
        "                                5. должен быть включен в один из рейтингов (применению подлежит актуальный рейтинг на последнюю отчетную дату и учитывается включение ключевого исполнителя в последнюю версию рейтинга российских ИТ-компаний), публикующихся на следующих информационных ресурсах:<br/>\n" +
        '                                • Раздел "ИТ-консалтинг (разработка и системная интеграция)" рэнкинга "Список крупнейших российских консалтинговых групп и компаний" Эксперт-РА (https://raex-a.ru/);<br/>\n' +
        "                                • Крупнейшие ИТ-компании России Cnews (www.cnews.ru);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Tadviser (www.tadviser.ru)."
    };
  },
  created() {
    this.siteUrl = AUTH_URL;
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "tree/industry",
      "code_okpd",
      "regions",
      "sp_monogorod",
      "list_import_plan",
      "product_plan_import",
      "start_pokazatel",
      "tree/vid_prom_products",
      "high_tehnology_sp"
    ]);

    if (this.project.SUBCONTRACTORS.length === 0) {
      //this.project.SUBCONTRACTORS.push({});
    }

    if (this.project.INDICATORS.items.length === 0) {
      this.project.INDICATORS.items = new Object();
    }
    let m = this;
    this.project.INDICATORS.INDICATORS_ID.forEach(function(indicator) {
      if (typeof m.project.INDICATORS.items[indicator] === "undefined") {
        Vue.set(m.project.INDICATORS.items, indicator, []);
      }
      for (
        let year = m.project.INDICATORS.yearStart;
        year <= m.project.INDICATORS.yearEnd;
        year++
      ) {
        let t = m.project.INDICATORS.items[indicator].filter(
          c => c.UF_INDICATORS_YEAR === year
        );
        if (t.length === 0) {
          m.project.INDICATORS.items[indicator].push({
            UF_INDICATORS_VALUE: 0,
            UF_INDICATORS_YEAR: year,
            UF_INDICATORS_ID: indicator
          });
        }
      }
    });

    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"])
      .then(() => {}, this);
  },
  methods: {
    getInfoproductionId(code) {
      let t = this.directory.tree_sp_infoproduction.filter(
        c => c.CODE === code
      );
      if (t.length > 0 && t[0].URL !== null) {
        return t[0].ID;
      }
      return "";
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID === id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    }
  },
  computed: {
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
